module.exports = __webpack_public_path__ + "static/media/Team 5 - Breakthrough.243c4e69.jpeg";